import { useTranslation } from "react-i18next";
import { UseFormReturn } from "react-hook-form";
import { Box, Stack, Theme } from "@mui/material";
import CheckboxInput from "src/components/Inputs/CheckboxInput";
import { ConnectConfirmFormValues } from "src/pages/SmartCharging/Onboarding/ConnectConfirm";

interface ConnectConfirmFormProps {
  form: UseFormReturn<ConnectConfirmFormValues, any, undefined>;
}

const ConnectConfirmForm = ({ form }: ConnectConfirmFormProps) => {
  const { t } = useTranslation();

  return (
    <Stack gap={2}>
      <CheckboxInput
        control={form.control}
        label={
          <Box
            sx={(theme: Theme) => ({
              color: theme.palette.mainFont.primary,
            })}
          >
            {t("page.wallboxConnectConfirm.checkbox1")}
          </Box>
        }
        name="wallboxConfigured"
      />

      <CheckboxInput
        control={form.control}
        label={
          <Box
            sx={(theme: Theme) => ({
              color: theme.palette.mainFont.primary,
            })}
          >
            {t("page.wallboxConnectConfirm.checkbox2")}
          </Box>
        }
        name="wallboxRestarted"
      />
    </Stack>
  );
};

export default ConnectConfirmForm;
